import { Button, DatePicker, Form, Input, Modal, Select, Space, Switch, TimePicker } from "antd";
import Axios from "axios";
import cogoToast from "cogo-toast";
import moment from "moment";
import React, { useEffect, useState } from "react";
import accountTitles from "../../config/accounts";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 6, offset: 1 },
    lg: { span: 6, offset: 0 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 12 },
    lg: { span: 12 },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: { span: 24, offset: 0 },
    sm: { span: 16, offset: 8 },
    md: { span: 12, offset: 6 },
    lg: { span: 7, offset: 7 },
  },
};

const api_url = process.env.REACT_APP_API_URL;
const token = localStorage.getItem("token_mg_WB");

const ClassModal = (props) => {
  const { formVisible, setFormVisible, onSuccess } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [sCourse, setSCourse] = useState(false);
  const [courses, setCourses] = useState([]);
  const [batches, setBatches] = useState([]);
  const [selectedBatchIds, setSelectedBatchIds] = useState([]);
  const [accountId, setAccountId] = useState(1);
  const [newLmsSelected, setNewLmsSelected] = useState(true); // Track the state of the newLMS switch to display thumbnail input
  const [isOnQuizrr, setIsOnQuizrr] = useState(false); // Track the state of the quizrr switch
  const [teachers, setTeachers] = useState([]);
  const [lmsContentTreeByBatch, setLmsContentTreeByBatch] = useState({}); // { [batchId]: tree }
  const [lmsTreeLoadingByBatch, setLmsTreeLoadingByBatch] = useState({}); // { [batchId]: bool }
  const [batchPlacement, setBatchPlacement] = useState({}); // { [batchId]: { subjectId, chapterId, topicId, contentId } }

  const fetchLmsContentTreeForBatch = (batchId) => {
    if (!batchId || lmsContentTreeByBatch[batchId] || lmsTreeLoadingByBatch[batchId]) return;
    setLmsTreeLoadingByBatch((prev) => ({ ...prev, [batchId]: true }));
    Axios.get(`${api_url}/class/lms-content-tree`, {
      params: { webinarBatchId: batchId },
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const { error, tree } = response.data;
        if (error) {
          cogoToast.error("Could not load LMS content tree for this batch", {
            position: "top-right",
          });
        } else {
          setLmsContentTreeByBatch((prev) => ({ ...prev, [batchId]: tree }));
        }
      })
      .catch(() => {
        cogoToast.error("Could not load LMS content tree for this batch", {
          position: "top-right",
        });
      })
      .finally(() =>
        setLmsTreeLoadingByBatch((prev) => ({ ...prev, [batchId]: false })),
      );
  };

  const setBatchPlacementField = (batchId, field, value) => {
    setBatchPlacement((prev) => {
      const next = {
        ...prev,
        [batchId]: { ...prev[batchId], [field]: value },
      };
      // Reset dependent, deeper selections when a shallower one changes
      if (field === "placementSubjectId") {
        next[batchId].chapterId = undefined;
        next[batchId].topicId = undefined;
        next[batchId].contentId = undefined;
      } else if (field === "chapterId") {
        next[batchId].topicId = undefined;
        next[batchId].contentId = undefined;
      } else if (field === "topicId") {
        next[batchId].contentId = undefined;
      }
      return next;
    });
  };

  useEffect(() => {
    Axios.get(`${api_url}/cb/course`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const { error, courses } = response.data;
      if (error) cogoToast.error("Could not load courses", { position: "top-right" });
      else setCourses(courses);
    });

    // Add new API call for teachers
    Axios.get(`${api_url}/teachers`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const { error, teachers } = response.data;
      if (error) cogoToast.error("Could not load teachers", { position: "top-right" });
      else setTeachers(teachers);
    });
  }, []);

  const onFinish = (values) => {
    setLoading(true);
    const {
      title,
      date,
      time,
      batch,
      courses,
      duration,
      isClassOnNewLms,
      thumbnailUrl,
      description,
      isMustDo,
      extHTML,
      teachers,
      isPublic,
      isOnQuizrr,
    } = values;

    const batches = batch.join();
    const batchTopicVideoMap = {};
    const batchSubjectIds = {};
    batch.forEach((batchId) => {
      const placement = batchPlacement[batchId] || {};
      const { subjectIds, chapterId, topicId, contentId } = placement;
      if (subjectIds && subjectIds.length > 0) {
        batchSubjectIds[batchId] = subjectIds;
      }
      if (topicId && chapterId) {
        batchTopicVideoMap[batchId] = { topicId, chapterId, ...(contentId && { contentId }) };
      }
    });
    if (title) {
      if (isClassOnNewLms) {
        if (!thumbnailUrl || !description) {
          cogoToast.error(
            "Please provide thumbnail URL and description in order to create class for new lms",
            { position: "top-right" },
          );
          return;
        }
        const missingSubject = batch.some(
          (batchId) => !batchSubjectIds[batchId] || batchSubjectIds[batchId].length === 0,
        );
        if (missingSubject) {
          cogoToast.error(
            "Please select at least one subject for every batch for the new lms class",
            { position: "top-right" },
          );
          return;
        }
      }
      let final_date = moment(date).startOf("day");
      let final_time = moment(time);
      let final_DT = final_date
        .add(final_time.hour(), "hour")
        .add(final_time.minute(), "minute")
        .add(5.5, "hour");
      let data = {
        title,
        batches,
        courses: courses.join(),
        duration,
        isClassOnNewLms,
        thumbnailUrl,
        description,
        isMustDo,
        accountId: parseInt(accountId),
        dateTime: final_DT,
        extHTML,
        teachers,
        isPublic,
        isOnQuizrr,
        batchSubjectIds,
        ...(Object.keys(batchTopicVideoMap).length > 0 && { batchTopicVideoMap }),
      };
      Axios.post(`${api_url}/class`, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((response) => {
          const { error, class: newClass } = response.data;
          if (error) {
            cogoToast.error("Error in creating class, please try again", { position: "top-right" });
            setLoading(false);
          } else {
            cogoToast.success(
              `Class created! Registering ${newClass?.schedulingJob?.total ?? 0} students in the background.`,
              { position: "top-right" },
            );
            setLoading(false);
            setFormVisible(false);
            form.resetFields();
            setLmsContentTreeByBatch({});
            setLmsTreeLoadingByBatch({});
            setBatchPlacement({});
            if (onSuccess) onSuccess();
          }
        })
        .catch((error) => {
          console.log(error);
          cogoToast.error("Error in creating event, please try again", {
            position: "top-right",
          });
          setLoading(false);
        });
    } else {
      cogoToast.error("No title provided", { position: "top-right" });
    }
  };

  return (
    <Modal
      visible={formVisible}
      footer={null}
      title="Create Class"
      width={800}
      onCancel={() => {
        setFormVisible(false);
      }}
    >
      <Form {...formItemLayout} form={form} onFinish={onFinish}>
        <Form.Item label="Title" name="title">
          <Input />
        </Form.Item>
        <Form.Item label="Date" name="date">
          <DatePicker />
        </Form.Item>
        <Form.Item label="Time" name="time">
          <TimePicker format="HH:mm" />
        </Form.Item>
        <Form.Item label="Course" name="courses">
          <Select
            mode="multiple"
            onChange={(selectedCourses) => {
              setSCourse(false);
              // Get all batches from selected courses
              const allBatches = [];
              selectedCourses.forEach((courseId) => {
                const course = courses.find((c) => c._id === courseId);
                if (course && course.batches) {
                  allBatches.push(...course.batches);
                }
              });
              setBatches(allBatches);
              setSCourse(true);
            }}
          >
            {courses
              ? courses.map((course) => {
                  return (
                    <Select.Option key={course._id} value={course._id}>
                      {course.title}
                    </Select.Option>
                  );
                })
              : null}
          </Select>
        </Form.Item>
        <Form.Item label="Batches" name="batch">
          <Select
            mode="multiple"
            onChange={(selectedBatches) => {
              let finalIds = selectedBatches;
              if (selectedBatches.includes("ALL")) {
                finalIds = batches.map((batch) => batch._id);
                form.setFieldsValue({ batch: finalIds });
              }
              setSelectedBatchIds(finalIds);
              if (newLmsSelected) {
                finalIds.forEach((batchId) => fetchLmsContentTreeForBatch(batchId));
              }
            }}
          >
            {batches && sCourse ? <Select.Option value="ALL">Select All</Select.Option> : null}
            {batches && sCourse
              ? batches.map((batch) => {
                  return (
                    <Select.Option key={batch._id} value={batch._id}>
                      {batch.title}
                    </Select.Option>
                  );
                })
              : null}
          </Select>
        </Form.Item>

        {newLmsSelected &&
          selectedBatchIds.map((batchId) => {
            const batchInfo = batches.find((b) => b._id === batchId);
            const placement = batchPlacement[batchId] || {};
            const treeLoading = lmsTreeLoadingByBatch[batchId];
            const tree = lmsContentTreeByBatch[batchId];
            const subjects = tree?.subjects || [];
            const selectedSubject = subjects.find((s) => s._id === placement.placementSubjectId);
            const chapters = selectedSubject?.chapters || [];
            const selectedChapter = chapters.find((c) => c._id === placement.chapterId);
            const topics = selectedChapter?.topics || [];
            const selectedTopic = topics.find((t) => t._id === placement.topicId);
            const content = selectedTopic?.content || [];

            return (
              <React.Fragment key={batchId}>
                <Form.Item
                  label={`Subjects (${batchInfo?.title || batchId})`}
                  required
                  help="Required — this batch's live class will be linked to all selected subjects"
                >
                  <Select
                    mode="multiple"
                    loading={treeLoading}
                    placeholder="Select one or more subjects"
                    value={placement.subjectIds || []}
                    onChange={(value) => setBatchPlacementField(batchId, "subjectIds", value)}
                  >
                    {subjects.map((s) => (
                      <Select.Option key={s._id} value={s._id}>
                        {s.title}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label={`Placement Subject (${batchInfo?.title || batchId})`}
                  help="Optional: which subject's chapter tree to browse below, for placing this class in a specific topic"
                >
                  <Select
                    allowClear
                    loading={treeLoading}
                    placeholder="Select subject to browse its chapters"
                    value={placement.placementSubjectId}
                    onChange={(value) =>
                      setBatchPlacementField(batchId, "placementSubjectId", value)
                    }
                  >
                    {subjects.map((s) => (
                      <Select.Option key={s._id} value={s._id}>
                        {s.title}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item label={`Chapter (${batchInfo?.title || batchId})`}>
                  <Select
                    allowClear
                    disabled={!placement.placementSubjectId}
                    placeholder="Select chapter"
                    value={placement.chapterId}
                    onChange={(value) => setBatchPlacementField(batchId, "chapterId", value)}
                  >
                    {chapters.map((c) => (
                      <Select.Option key={c._id} value={c._id}>
                        {c.title}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item label={`Topic (${batchInfo?.title || batchId})`}>
                  <Select
                    allowClear
                    disabled={!placement.chapterId}
                    placeholder="Select topic"
                    value={placement.topicId}
                    onChange={(value) => setBatchPlacementField(batchId, "topicId", value)}
                  >
                    {topics.map((t) => (
                      <Select.Option key={t._id} value={t._id}>
                        {t.title}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label={`Content (${batchInfo?.title || batchId})`}
                  help="Optional: pick an existing content entry to attach this class to, instead of creating a new placeholder"
                >
                  <Select
                    allowClear
                    disabled={!placement.topicId}
                    placeholder="Select existing content (optional)"
                    value={placement.contentId}
                    onChange={(value) => setBatchPlacementField(batchId, "contentId", value)}
                  >
                    {content.map((c) => (
                      <Select.Option key={c._id} value={c._id}>
                        {c.title} ({c.type})
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </React.Fragment>
            );
          })}
        <Form.Item label="Teachers" name="teachers">
          <Select mode="multiple">
            {teachers.map((teacher) => (
              <Select.Option key={teacher._id} value={teacher._id}>
                {teacher.name} ({teacher.email})
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Duration" name="duration">
          <Input />
        </Form.Item>
        <Form.Item label="Zoom Account" name="zoomAccount">
          <Select
            defaultValue="1"
            options={accountTitles}
            value={accountId}
            onChange={(value) => {
              setAccountId(value);
            }}
          />
        </Form.Item>
        <Form.Item
          label="Is on lms:"
          name="isClassOnNewLms"
          valuePropName="checked"
          className="custom-label"
          initialValue={true}
        >
          <Switch
            className="custom-switch"
            onChange={(checked) => setNewLmsSelected(checked)}
            checked={newLmsSelected}
          />
        </Form.Item>

        <Form.Item
          label="Is on quizrr:"
          name="isOnQuizrr"
          valuePropName="checked"
          className="custom-label"
          initialValue={false}
        >
          <Switch
            className="custom-switch"
            onChange={(checked) => setIsOnQuizrr(checked)}
            checked={isOnQuizrr}
          />
        </Form.Item>

        <Form.Item
          label="Is public:"
          name="isPublic"
          valuePropName="checked"
          className="custom-label"
          initialValue={false}
        >
          <Switch className="custom-switch" />
        </Form.Item>

        {newLmsSelected && (
          <Form.Item label="Thumbnail URL" name="thumbnailUrl" initialValue="#">
            <Input />
          </Form.Item>
        )}

        {(newLmsSelected || isOnQuizrr) && (
          <Form.Item label="Description" name="description" initialValue="Live Class">
            <Input />
          </Form.Item>
        )}

        {newLmsSelected && (
          <Form.Item label="is Must Do" name="isMustDo" initialValue={false}>
            <Switch className="custom-switch" />
          </Form.Item>
        )}

        <Form.Item label="Extra HTML" name="extHTML">
          <Input />
        </Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <Space size="large">
            <Button htmlType="submit" size="large" loading={loading} type="primary">
              Create New Class
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const LinkModal = (props) => {
  const { linkVisible, setLinkVisible } = props;
  const [classes, setClasses] = useState();
  const [link, setLink] = useState();
  const [form] = Form.useForm();
  const onFinish = async (values) => {
    const { email, class_id } = values;
    const { data } = await Axios.get(`${api_url}/class/link`, {
      params: { email, class_id },
      headers: { Authorization: `Bearer ${token}` },
    });
    const { error, link } = data;
    if (error || !link) cogoToast.error("Error fetching link");
    else setLink(link);
  };

  useEffect(() => {
    Axios.get(`${api_url}/class`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const { error, classes } = response.data;
      if (error) {
        cogoToast.error("Could not load classes", { position: "top-right" });
      } else {
        setClasses(classes);
      }
    });
  }, []);
  return (
    <Modal
      width={600}
      title="Search Link"
      visible={linkVisible}
      footer={null}
      onCancel={() => {
        setLinkVisible(false);
      }}
    >
      <Form {...formItemLayout} form={form} onFinish={onFinish}>
        <Form.Item label="Email" name="email">
          <Input type="email" />
        </Form.Item>
        <Form.Item label="Class" name="class_id">
          <Select>
            {classes
              ? classes.map((c) => (
                  <Select.Option key={c._id} value={c._id}>
                    {c.title}
                  </Select.Option>
                ))
              : null}
          </Select>
        </Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <Space size="large">
            <Button htmlType="submit" size="large" type="primary">
              Search
            </Button>
          </Space>
        </Form.Item>
        <Form.Item label="Link">
          {link ? <span>{link}</span> : "Fill details and press search to get link"}
        </Form.Item>
      </Form>
    </Modal>
  );
};

const EndModal = (props) => {
  const { endVisible, setEndVisible, classId } = props;
  const [notify, setNotify] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    const { extHTML } = values;
    const { data } = await Axios.patch(
      `${api_url}/class/end`,
      { class_id: classId, extHTML, notify: notify ? "yes" : "no" },
      { headers: { Authorization: `Bearer ${token}` } },
    );
    if (data.error) cogoToast.error("Error ending class", { position: "top-right" });
    else cogoToast.success("Ended class and notified", { position: "top-right" });
  };

  return (
    <Modal
      width={600}
      title="End Class"
      visible={endVisible}
      footer={null}
      onCancel={() => {
        setEndVisible(false);
      }}
    >
      <Form {...formItemLayout} form={form} onFinish={onFinish}>
        <Form.Item label="Extra HTML" name="extHTML">
          <Input placeholder="(optional)" />
        </Form.Item>

        <Form.Item label="Notify (Email)">
          <Switch checked={notify} onChange={(e) => setNotify(e.valueOf())}></Switch>
        </Form.Item>

        <Form.Item {...tailFormItemLayout}>
          <Space size="large">
            <Button htmlType="submit" size="large" type="danger">
              End Class
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export { ClassModal, EndModal, LinkModal };
